var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoguide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 3.75C4.16973 3.75 3.75 4.16973 3.75 4.6875V13.3125C3.75 13.8303 4.16973 14.25 4.6875 14.25H13.3125C13.8303 14.25 14.25 13.8303 14.25 13.3125V10.5C14.25 10.0858 14.5858 9.75 15 9.75C15.4142 9.75 15.75 10.0858 15.75 10.5V13.3125C15.75 14.6587 14.6587 15.75 13.3125 15.75H4.6875C3.3413 15.75 2.25 14.6587 2.25 13.3125V4.6875C2.25 3.3413 3.3413 2.25 4.6875 2.25H7.5C7.91423 2.25 8.25 2.58579 8.25 3C8.25 3.41421 7.91423 3.75 7.5 3.75H4.6875ZM10.5 3.75C10.0858 3.75 9.75 3.41421 9.75 3C9.75 2.58579 10.0858 2.25 10.5 2.25H15C15.4142 2.25 15.75 2.58579 15.75 3V7.5C15.75 7.91423 15.4142 8.25 15 8.25C14.5858 8.25 14.25 7.91423 14.25 7.5V4.81066L11.0303 8.03032C10.7374 8.3232 10.2626 8.3232 9.96968 8.03032C9.6768 7.73745 9.6768 7.26257 9.96968 6.96967L13.1894 3.75H10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoguide);
export default __webpack_public_path__ + "static/media/videoguide.3ab0b78374d5da517cc23f8fa3d1696e.svg";
export { ForwardRef as ReactComponent };